import React, { Component, Fragment, ReactNode } from 'react';
import { withRouteData, Switch, Route } from 'react-static';
import { SingleColumnLayout } from '@flow/components/ui';
import { IFoods } from 'types/IFoods';
import { IPage } from 'types/IPage';
import * as NavigationAction from '@flow/store/navigation/actions';
import { connect } from 'react-redux';
import SEOTags from '@flow/components/seo/SEOTags';
import { renderContent } from '@flow/scenes/default/ui';
import PageSubnavigation from '@flow/scenes/default/ui/PageSubnavigation';
import { PageTitle, SingleColumnLayoutContentWrapper } from '@flow/components/ui';
import DefaultPage from '@flow/scenes/default/DefaultPage';
import SimplePage from '@flow/scenes/simple/SimplePage';
import { TextAnimation } from '@flow/components/animation/TextAnimation';
import { renderList } from '@flow/components/grid/grid';
import {TagList} from "@flow/components/tags/tags";
import {IFood} from "types/IFood";

interface Props {
  appLanguage: IAppLanguage;
  restaurants: IFoods;
  slugBases: any;
  page: IPage;
  _setLanguage: any;
  match: any;
}

interface State {
  tags: string[];
  canTitleAnimate: boolean;
}

class Foods extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      tags: [],
      canTitleAnimate: false
    };
  }

  componentWillMount() {
    const {
      appLanguage,
      _setLanguage,
      page,
    } = this.props;

    const lang_versions = page && page.lang_versions;

    _setLanguage({ appLanguage, lang_versions});
  }

  componentWillReceiveProps({
      appLanguage,
      page,
    }: Props) {
    const {
      _setLanguage,
    } = this.props;

    const lang_versions = page && page.lang_versions;

    _setLanguage({ appLanguage, lang_versions });
  }

  componentDidMount() {
    this.setState({canTitleAnimate: true});
  }

  render() {
    const {
      match: {
        url
      }
    } = this.props;

    return (
      <Switch>
        <Route
          path={url}
          exact
          render={() => {
            return this._renderPageLayout();
          }}
        />
        <Route path={`${url}/:foodId/`} component={SimplePage} />
      </Switch>
    );
  }

  private _renderPageLayout = (): ReactNode => {
    const {
      page,
      restaurants,
        appLanguage
    } = this.props;


    const shared = [{name: 'All vegan'}, {name: 'Vegan'}, {name: 'Seafood and fish'}, {name: 'Sweet'}, {name: 'Coffee'}, {name: 'Bar'}]
    let filters = [...shared];
    if (appLanguage.code === 'fi') {
      filters = [...[{name: 'Gluteeniton'}, {name: 'Laktoositon'}],...filters]
    } else if (appLanguage.code === 'en') {
      filters = [...[{name: 'Gluten free'}, {name: 'Lactose free'}], ...filters]
    }

    const { canTitleAnimate } = this.state;

    if (restaurants) {
      const {
        title,
        content_group,
        side_navigation
      } = page;

      let visibleRestaurants = this._getVisibleRestaurants(
          restaurants,
          {tags: this.state.tags}
      );

      return (
        <Fragment>
          <SEOTags page={page} />
          <SingleColumnLayout>
            <PageSubnavigation navigation={side_navigation}/>
            <PageTitle>
              <TextAnimation text={title} animateIn={canTitleAnimate} />
            </PageTitle>
            <SingleColumnLayoutContentWrapper>
            { renderContent(content_group) }
            </SingleColumnLayoutContentWrapper>
            <TagList tagsUpdated={(tags: string[]) => this.setState({tags})} tags={filters} />
            { renderList('food', visibleRestaurants) }
          </SingleColumnLayout>
        </Fragment>
      )
    } else {
      return (
        <DefaultPage {...this.props}/>
      )
    }
  };

  private _getVisibleRestaurants = (restaurants: IFoods, filters: {tags: string[]}): IFoods => {
    const filterKeys = Object.keys(filters);
    return restaurants.filter((restaurant: IFood) => {
      return filterKeys.every(key => {
        if (!filters[key].length) {
          return restaurants;
        }

        if (restaurant[key].length === 0)
          return false;

        return restaurant[key].find(tag => filters[key].includes(tag.name));
      });
    });
  };
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    _setLanguage: ({appLanguage, lang_versions }: ISetLanguage) => {
      dispatch(NavigationAction.setLanguage(appLanguage, lang_versions));
    }
  };
};

export default connect(
  null,
  mapDispatchToProps
)(withRouteData(Foods));


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/foods/Foods.tsx